module.exports = __webpack_public_path__ + "static/media/thanksforallthefish.3160f725.jpg";